import $ from "jquery";
import fb from "../../core/firebase";
import bdjs from "../../core/bdjs";

export const Welcome = () => {
	const welcomePage = $("#welcome");
	if (welcomePage.length === 0) return false;

	const $elems = {
		welcomePage: $("#welcome"),
		entryCode: $("#entry-code"),
		btnEnterGame: $("#btn-enter-game"),
		btnBack: $(".back-button"),
		btnStartGame: $(".play-button"),
		snackbar: $(".snackbar"),
		startOverlay: $(".start-overlay"),
		countdownNumber: $(".countdown-number"),
		countdownRing: $(".countdown-ring__circle"),
	}

	let countdownInterval = null;
	let firebase = fb();
	let currentTeamCode = null;

	const onSubmit = () => {
		const entryCode = $elems.entryCode.val();
		if (entryCode.length === 0) return false;

		const isLoading = $elems.btnEnterGame.hasClass('is-loading');
		if (isLoading) return false;

		$elems.btnEnterGame.addClass('is-loading');
		$elems.snackbar.removeClass(['is-correct', 'is-incorrect']);

		$.ajax({
			url: window.CFG.ajax_url,
			type: 'POST',
			data: {
				action: 'join_game',
				team_code: entryCode,
				nonce: window.CFG.nonce,
			},
			success: async (response) => {
				if (response.success) {
					$elems.btnEnterGame.prop("disabled", true);
					$elems.welcomePage.addClass('is-correct');
					$elems.snackbar.addClass('is-correct');
					$elems.snackbar.find('.snackbar__content').text(response.data.message);
					$elems.snackbar.addClass('is-open');

					// Initialize Firebase and add player to team
					let firebaseSuccess = false;
					try {
						const initialized = await firebase.init(response.data.auth_token);
						if (initialized) {
							await firebase.addPlayerToTeam(entryCode, response.data.user_id);
							await firebase.firebaseListener(entryCode);
							firebaseSuccess = true;
							// Store the team code for later use
							currentTeamCode = entryCode;
						}
					} catch (error) {
						console.error('Firebase error:', error);
					}

					setTimeout(() => {
						$elems.welcomePage.removeClass('is-correct');
						$elems.snackbar.removeClass('is-open');

						if (firebaseSuccess) {
							// Proceed to next step
							$elems.welcomePage.addClass('expanded');
						} else {
							// Show error and don't proceed
							$elems.welcomePage.addClass('is-incorrect');
							$elems.snackbar.addClass('is-incorrect');
							$elems.snackbar.find('.snackbar__content').text('Failed to connect to game server');
							$elems.snackbar.addClass('is-open');

							setTimeout(() => {
								$elems.welcomePage.removeClass('is-incorrect');
								$elems.snackbar.removeClass('is-open');
							}, 5000);
						}
					}, 1000);
				} else {
					$elems.welcomePage.addClass('is-incorrect');
					$elems.snackbar.addClass('is-incorrect');
					$elems.snackbar.find('.snackbar__content').text(response.data.message);
					$elems.snackbar.addClass('is-open');
					setTimeout(() => {
						$elems.welcomePage.removeClass('is-incorrect');
						$elems.snackbar.removeClass('is-open');
					}, 5000);
				}
			},
			error: (error) => {
				console.error(error);
				$elems.snackbar.find('.snackbar__content').text('An error occurred');
				$elems.snackbar.addClass('is-incorrect');
				$elems.snackbar.addClass('is-open');
				setTimeout(() => {
					$elems.snackbar.removeClass('is-open');
				}, 5000);
			},
			complete: () => {
				$elems.btnEnterGame.removeClass('is-loading');
			},
		})
	}

	const validateEntryCode = () => {
		let inputValue = $elems.entryCode.val();
		const inputLength = inputValue.length;

		if (inputLength > 6) {
			$elems.entryCode.val(inputValue.substring(0, 6));
			return false;
		}

		if (inputLength === 6) {
			$elems.btnEnterGame.prop("disabled", false);
		} else {
			$elems.btnEnterGame.prop("disabled", true);
		}
	}

	const onBack = () => {
		$elems.welcomePage.removeClass('expanded');

		// Clear countdown if running
		if (countdownInterval) {
			clearInterval(countdownInterval);
			countdownInterval = null;
		}

		// Remove Firebase listener if team code exists
		if (currentTeamCode) {
			const teamPath = firebase.getTeamPath(currentTeamCode);
			firebase.offValue(teamPath);
		}

		// Reset countdown state
		$elems.startOverlay.removeClass('is-countdown');
		$elems.countdownNumber.text('5');
		$elems.countdownRing.css('stroke-dashoffset', 0);
		validateEntryCode();
	}

	const onStartGame = () => {
		// Show countdown in place of play button
		$elems.startOverlay.addClass('is-countdown');

		let count = 5;
		const circumference = 2 * Math.PI * 174; // 1092.61

		// Start countdown
		countdownInterval = setInterval(() => {
			count--;

			if (count >= 0) {
				// Update number
				$elems.countdownNumber.text(count);

				// Animate ring
				const offset = circumference - (circumference * count / 5);
				$elems.countdownRing.css('stroke-dashoffset', offset);

				// Add pulse animation
				$elems.countdownNumber.css('animation', 'none');
				setTimeout(() => {
					$elems.countdownNumber.css('animation', 'countdown-pulse 1s ease-in-out infinite');
				}, 10);
			} else {
				// Clear interval and redirect
				clearInterval(countdownInterval);
				countdownInterval = null;
				window.location.href = window.CFG.waiting_room_url;
			}
		}, 1000);
	}

	const onTeamStateChanged = (event, eData) => {
		const data = eData.data;

		if (data.is_starting) {
			onStartGame();
		}
	}

	$elems.btnEnterGame.on("click", onSubmit);
	$elems.entryCode.on("input", validateEntryCode);
	$elems.btnBack.on("click", onBack);
	$elems.btnStartGame.on("click", async () => {
		if (currentTeamCode) {
			await firebase.update(firebase.getTeamPath(currentTeamCode), { is_starting: true });
		}
	});
	bdjs.listen("bd__teamAttributeChanged", onTeamStateChanged);
	validateEntryCode();
}